var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _vm.voucherId
            ? _c(
                "v-col",
                { staticClass: "pt-5", attrs: { cols: "1" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { dark: "", block: "", color: "green" },
                      on: {
                        click: function($event) {
                          return _vm.$router.push({
                            name: "vouchers.petty-cash.create",
                            params: { voucherId: _vm.voucherId }
                          })
                        }
                      }
                    },
                    [_c("span", [_vm._v("new")])]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.voucherIndexList,
                  "item-value": "id",
                  "item-text": "voucher_no",
                  "no-filter": "",
                  label: "Voucher",
                  "search-input": _vm.searchVoucher,
                  clearable: "",
                  loading: _vm.voucherIndexGetting
                },
                on: {
                  "update:searchInput": function($event) {
                    _vm.searchVoucher = $event
                  },
                  "update:search-input": function($event) {
                    _vm.searchVoucher = $event
                  }
                },
                model: {
                  value: _vm.voucherId,
                  callback: function($$v) {
                    _vm.voucherId = $$v
                  },
                  expression: "voucherId"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("pt-cash-voucher-table", {
        ref: "ptCashVoucherTable",
        on: { show: _vm.showPtCash }
      }),
      _c("pt-cash-voucher-show", {
        attrs: { "pt-cash-voucher-id": _vm.ptCashVoucherId },
        on: { approve: _vm.approvePtCash, reject: _vm.rejectPtCash },
        model: {
          value: _vm.showPtCashVoucher,
          callback: function($$v) {
            _vm.showPtCashVoucher = $$v
          },
          expression: "showPtCashVoucher"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }